import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /**
   * Must match the name of an icon generated by the icon font
   */
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  /**
   * Aria label for the button
   */
  ariaLabel: PropTypes.string,
  classList: PropTypes.string,
  isDisabled: PropTypes.bool,
  labelText: PropTypes.string,
  theme: PropTypes.oneOf(['', 'inverse', 'translucent']),
  /**
   * [Button type attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#attr-type)
   */
  type: PropTypes.string,
  variant: PropTypes.oneOf(['', 'square'])
};
function IconButton(_ref) {
  var ariaLabel = _ref.ariaLabel,
    icon = _ref.icon,
    _ref$classList = _ref.classList,
    classList = _ref$classList === void 0 ? '' : _ref$classList,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    onClick = _ref.onClick,
    labelText = _ref.labelText,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? null : _ref$theme,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? null : _ref$variant;
  return /*#__PURE__*/React__default.createElement("button", {
    "aria-label": ariaLabel || labelText,
    className: "icon-button ".concat(classList),
    "data-theme": theme,
    "data-variant": variant,
    disabled: isDisabled,
    onClick: onClick,
    type: type
  }, /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true",
    "data-icon": icon,
    "data-testid": "icon-button-icon"
  }));
}
IconButton.propTypes = propTypes;

export { IconButton as default };
//# sourceMappingURL=IconButton.js.map
